<template>
  <div>
    <van-dropdown-menu active-color="#0091C5">
      <van-dropdown-item @change="value1Change" v-model="value1" :options="option1"/>
      <van-dropdown-item @change="value2Change" v-model="value2" :options="option2"/>
      <van-dropdown-item @change="value3Change" v-model="value3" :options="option3"/>
    </van-dropdown-menu>
  </div>
</template>

<script>
export default {
  name: "SearchSifting",
  data() {
    return {
      value1: 0,
      value2: null,
      value3: null,
      option1: [
        { text: '综合排序', value: 0 },
        { text: '最高人气', value: 1},
        { text: '最新发布', value: 2 },
      ],
      option2: [
        { text: '亚专业', value: null },
      ],
      option3: [
        { text: '检查类型', value: null },
      ],
    }
  },
  mounted() {
    this.getLabel2()
    this.getLabel3()
  },
  methods: {
    value1Change(val) {
      this.$emit('change', {
        type: 1,
        value: val
      })
    },
    value2Change(val) {
      this.$emit('change', {
        type: 2,
        value: val
      })
    },
    value3Change(val) {
      this.$emit('change', {
        type: 3,
        value: val
      })
    },
    getLabel2() {
      this.$http.get(this.$api.label2.list).then(res => {
        res.data.map(list => {
          let item = {
            value: list.name,
            text: list.name
          }
          this.option2.push(item)
        })
      })
    },
    getLabel3() {
      this.$http.get(this.$api.label3.list).then(res => {
        res.data.map(list => {
          let item = {
            value: list.name,
            text: list.name
          }
          this.option3.push(item)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-dropdown-menu__bar {
    border-top: 1px solid #eeeeee;
    box-shadow: none;
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 0;
  }
}
</style>
